// @flow

type FontFamily = { [string]: string };

const fontFamily: FontFamily = Object.freeze({
  display: 'Gilroy, "Open Sans", OpenSans, Arial, "Helvetica Neue", Helvetica, sans-serif',
  sansSerif: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif',
});

type Color = (brightness: number | string, opacity?: number | string) => string;
type Colors = { [string]: Color };

const colors: Colors = Object.freeze({
  black: (b, o = 1) => `hsla(0, 0%, ${b}%, ${o})`,
  white: (b, o = 1) => `hsla(0, 0%, 100%, ${o})`,
  blue:  (b, o = 1) => `hsla(204, 77%, ${b}%, ${o})`,
  gray:  (b, o = 1) => `hsla(0, 0%, ${b}%, ${o})`,
  green: (b, o = 1) => `hsla(119, 32%, ${b}%, ${o})`,
  danger: (b, o = 1) => `hsla(1, 65%, ${b}%, ${o})`,
});

const device = Object.freeze({
  sm: 'min-width: 321px',
});

export const theme = Object.freeze({
  colors,
  device,
  fontFamily,
});
